import { ROLES } from '~/constant';
import { useAuthStore } from '~/stores';
export const useAuth = () => {
	const user = useAuthStore((state) => state.user);
	const idForm = useAuthStore((state) => state.idForm);
	const avatar = useAuthStore((state) => state.avatar);
	const role = useAuthStore((state) => state.role) || ROLES.AGENT;
	const token = useAuthStore((state) => state.token);
	const logoutAction = useAuthStore((state) => state.logoutAction);
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
	const companyCode = useAuthStore((state) => state.companyCode);
	return {
		user,
		role,
		idForm,
		avatar,
		companyCode,
		token,
		logoutAction,
		isAuthenticated,
	};
};
